// Test IDs for the Gear & Photography Library (public pages + admin CMS tab).

export const GEAR_LIBRARY_PAGE = {
  root: 'gear-library-page',
  grid: 'gear-library-grid',
  searchInput: 'gear-library-search-input',
  typeFilter: (type) => `gear-library-filter-${type}`,
  card: (slug) => `gear-library-card-${slug}`,
  emptyState: 'gear-library-empty-state',
};

export const GEAR_LIBRARY_DETAIL_PAGE = {
  root: 'gear-library-detail-page',
  backLink: 'gear-library-detail-back-link',
  specsTable: 'gear-library-detail-specs-table',
  goodForList: 'gear-library-detail-good-for-list',
};

export const ADMIN_GEAR_LIBRARY = {
  tab: 'admin-tab-gear-library',
  root: 'admin-gear-library-tab',
  table: 'admin-gear-library-table',
  generateButton: 'admin-gear-generate-button',
  generateDialog: 'admin-gear-generate-dialog',
  generateTypeSelect: 'admin-gear-generate-type-select',
  generateTitleInput: 'admin-gear-generate-title-input',
  generateBrandInput: 'admin-gear-generate-brand-input',
  generateHintsInput: 'admin-gear-generate-hints-input',
  generateSubmit: 'admin-gear-generate-submit-button',
  row: (id) => `admin-gear-row-${id}`,
  statusBadge: (id) => `admin-gear-status-${id}`,
  editButton: (id) => `admin-gear-edit-${id}`,
  publishButton: (id) => `admin-gear-publish-${id}`,
  unpublishButton: (id) => `admin-gear-unpublish-${id}`,
  deleteButton: (id) => `admin-gear-delete-${id}`,
  editDialog: 'admin-gear-edit-dialog',
  editTitleInput: 'admin-gear-edit-title-input',
  editBrandInput: 'admin-gear-edit-brand-input',
  editSummaryInput: 'admin-gear-edit-summary-input',
  editContentInput: 'admin-gear-edit-content-input',
  editGoodForInput: 'admin-gear-edit-good-for-input',
  editAliasesInput: 'admin-gear-edit-aliases-input',
  editSaveButton: 'admin-gear-edit-save-button',
  bulkButton: 'admin-gear-bulk-generate-button',
  bulkDialog: 'admin-gear-bulk-generate-dialog',
  bulkItemCheckbox: (key) => `admin-gear-bulk-item-${key}`,
  bulkSubmit: 'admin-gear-bulk-generate-submit-button',
  bulkProgress: 'admin-gear-bulk-generate-progress',
};
